/**
 * Fleet Routes Configuration
 * ==========================
 * React Router configuration for fleet management pages.
 * Add this to your main App.jsx or routes configuration.
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Fleet Components (same directory)
import FleetHome from './FleetHome';
import FleetDashboard from './FleetDashboard';
import FleetVehicleList from './FleetVehicleList';
import VehicleDetailPage from './VehicleDetailPage';
import AddVehicleWizard from './AddVehicleWizard';
import LogServiceRecord from './LogServiceRecord';
import FleetCostReports from './FleetCostReports';

// Placeholder components for pages not yet built
const DriversPage = () => <div className="p-8">Drivers management coming soon</div>;
const DepartmentsPage = () => <div className="p-8">Departments management coming soon</div>;
const BulkImportPage = () => <div className="p-8">Bulk import coming soon</div>;
const EditVehiclePage = () => <div className="p-8">Edit vehicle coming soon</div>;

// Create Fleet Page (reuses the form from FleetHome)
const CreateFleetPage = () => {
  const navigate = require('react-router-dom').useNavigate();
  const handleSuccess = (fleet) => navigate(`/fleet/${fleet.id}`);
  
  // Import the CreateFleetForm from FleetHome
  return (
    <div className="min-h-screen bg-gradient-to-br from-ink via-accent to-ink flex items-center justify-center p-4">
      <div className="max-w-4xl w-full text-center">
        <p className="text-white mb-4">Redirecting to fleet creation...</p>
        <a href="/fleet" className="text-accent hover:text-accent-hover">Go to Fleet Home</a>
      </div>
    </div>
  );
};

/**
 * Fleet Routes Component
 * 
 * Usage in App.jsx:
 * 
 * import FleetRoutes from './routes/FleetRoutes';
 * 
 * <Routes>
 *   <Route path="/fleet/*" element={<FleetRoutes />} />
 * </Routes>
 */
const FleetRoutes = () => {
  return (
    <Routes>
      {/* Fleet Home - shows list or create form */}
      <Route index element={<FleetHome />} />
      
      {/* Create new fleet */}
      <Route path="new" element={<FleetHome />} />
      
      {/* Fleet Dashboard */}
      <Route path=":fleetId" element={<FleetDashboard />} />
      
      {/* Vehicles */}
      <Route path=":fleetId/vehicles" element={<FleetVehicleList />} />
      <Route path=":fleetId/vehicles/add" element={<AddVehicleWizard />} />
      <Route path=":fleetId/vehicles/import" element={<BulkImportPage />} />
      <Route path=":fleetId/vehicles/:vehicleId" element={<VehicleDetailPage />} />
      <Route path=":fleetId/vehicles/:vehicleId/edit" element={<EditVehiclePage />} />
      <Route path=":fleetId/vehicles/:vehicleId/service/new" element={<LogServiceRecord />} />
      
      {/* Drivers */}
      <Route path=":fleetId/drivers" element={<DriversPage />} />
      
      {/* Departments */}
      <Route path=":fleetId/departments" element={<DepartmentsPage />} />
      
      {/* Reports */}
      <Route path=":fleetId/reports" element={<FleetCostReports />} />
      
      {/* Maintenance (alias to dashboard maintenance section) */}
      <Route path=":fleetId/maintenance" element={<Navigate to="../" replace />} />
    </Routes>
  );
};

export default FleetRoutes;


/**
 * Example App.jsx integration:
 * 
 * import { BrowserRouter, Routes, Route } from 'react-router-dom';
 * import FleetRoutes from './routes/FleetRoutes';
 * import Layout from './components/Layout';
 * 
 * function App() {
 *   return (
 *     <BrowserRouter>
 *       <Routes>
 *         <Route path="/" element={<Layout />}>
 *           {/* Other routes *\/}
 *           <Route path="fleet/*" element={<FleetRoutes />} />
 *         </Route>
 *       </Routes>
 *     </BrowserRouter>
 *   );
 * }
 */
